import axios from "axios";

const getApiBase = () => String(process.env.REACT_APP_API_BASE || "/api").replace(/\/$/, "");

export const getAppointmentDocumentId = (appointment) =>
  String(appointment?.docId || appointment?.id || "").trim();

const deleteAppointment = (route, parentId, appointmentId) => {
  const normalizedParentId = String(parentId || "").trim();
  const normalizedAppointmentId = String(appointmentId || "").trim();

  if (!normalizedParentId || !normalizedAppointmentId) {
    return Promise.reject(new Error("Identificatorul înscrierii lipsește."));
  }

  return axios.delete(`${getApiBase()}${route}`, {
    params: {
      id: normalizedParentId,
      appointmentId: normalizedAppointmentId,
    },
  });
};

export const deleteEventAppointment = (eventId, appointmentId) =>
  deleteAppointment("/appointment/delete", eventId, appointmentId);

export const deleteCampaignAppointment = (campaignId, appointmentId) =>
  deleteAppointment("/appointment-campaign/delete", campaignId, appointmentId);
